import { anInsight, mockRelatedSignalTimelineQueryQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockRelatedSignalTimelineQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insight: anInsight(),
        },
      });
    }
  ),
];
